import { observer, inject } from "mobx-react";
import { useState, useEffect } from "react";
import LoadingContainer from "../layouts/LoadingContainer";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../layouts/Header";
import SideBar from "../layouts/SideBar";
import { useTranslation } from "react-i18next";
import { useMobile } from "../utils/mobile";
import AdminMobileHeader from "../layouts/AdminMobileHeader";

const Admin = ({ userStore, tenantsStore }) => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [title, setTitle] = useState(t("menu:admin"));
  const isMobile = useMobile();
  const isListView = useLocation().pathname.endsWith("/list");

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      tenantsStore.setError("");

      const data = {
        MAINCUST: userStore.userDetails.MAINCUST,
        CUST: userStore.userDetails.CUST,
        MAINENV: userStore.userDetails.MAINENV,
        CUSTNAME: userStore.userDetails.CUSTNAME,
        USERNAME: userStore.userDetails.USERNAME,
      };
      await tenantsStore.updateCustomerUsers(data)
      await tenantsStore.getCustomerData(data)



      setLoading(false);
    };
    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ height: "100vh" }}>
      <LoadingContainer isLoading={isLoading}>
        {isMobile ? (
          isListView ? (
            // List screens: fixed header + its own scrolling content area.
            <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
              <AdminMobileHeader />
              <div
                style={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                  backgroundColor: "#f7f5ff",
                }}
              >
                <Outlet />
              </div>
            </div>
          ) : (
            // Hero screens: header + content scroll in one flow so the first
            // card can float up and overlap the curved purple hero (a separate
            // scroll box would clip the negative margin).
            <div
              style={{
                height: "100vh",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                backgroundColor: "#f7f5ff",
              }}
            >
              <AdminMobileHeader />
              <Outlet />
            </div>
          )
        ) : (
          <SideBar
            logo={userStore.userDetails.LOGO}
            setTitle={setTitle}
            admin={true}
          >
            <Header
              name={userStore.userDetails.NAME}
              title={title}
              admin={true}
            />
            <Outlet />
          </SideBar>
        )}
      </LoadingContainer>
    </div>
  );
};

export default inject("userStore", "tenantsStore")(observer(Admin));
